import { isNil } from "lodash";

/**
 * Move an item to a new position of the list
 * @param {Immutable.List} list
 * @param {number} from the index from
 * @param {number} to the index to
 */
const moveItemInList = (list, from, to) => {
  const movingItem = list.get(from);

  if (isNil(movingItem) || to > list.size) {
    //eslint-disable-next-line no-console
    console.log(`ERROR: moveItemInList(): called with from=${from}, to=${to}, with list.size = ${list.size}, isNil(movingItem) = ${isNil(movingItem)}... will lead to a null value so bailing without change. Printing list`);
    //eslint-disable-next-line no-console    
    console.dirJs(list);
    return list;
  }

  return list.remove(from).insert(to, movingItem);
};

export { moveItemInList };
